import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { KTIcon, KTSVG } from "../../../_metronic/helpers";
import { CustomFieldInitialsForAdd, CustomFieldInitialsForUpdate } from "./interfaces/CustomFieldClass";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { addAccountCustomFieldAsync, updateAccountCustomFieldAsync, resetSelectedRecordObjectInState, getDataByMasterEntityTypeIdAsync } from "./CustomFieldSlice";
import Select, { StylesConfig } from 'react-select';
import fetchAPI from "../../../common/fetchAPI";
import { ShowToast } from '../../../common/Toastr';
import * as yup from 'yup';
import { Formik, useFormik } from 'formik';
import { dropDownSelectionStyles,getValueFromResource } from '../../../common/timeLiveFunction';



export const CustomFieldManageForm = (props: any) => {

    const { MasterEntityTypeId, t } = props;
    const [currentFieldsData, setCurrentFieldsData] = useState<any>(CustomFieldInitialsForAdd)
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const [selectedDataTypeOptionDropDown, setSelectedDataTypeOptionDropDown] = useState<{ [object: string]: any }>();
    const [selectedDataTypeOptionDropDownValue, setSelectedDataTypeOptionDropDownValue] = useState('');
    const [selectedDefaultValueOptionDropDown, setSelectedDefaultValueOptionDropDown] = useState('');
    const [dataTypeArray, setDataTypeArray] = useState<any | ''>([]);
    const { selectedRecord, isLoading } = useAppSelector((state) => state.customField);
    const dispatch = useAppDispatch();
    const [selectedItems, setSelectedItems] = useState<string[]>([]);
    const [inputValue, setInputValue] = useState<string>('');
    const selectRef = useRef<HTMLSelectElement>(null);
    const [selectedItemToUpdate, setSelectedItemToUpdate] = useState<string | null>(null);
    const [DefaultValueArray, setDefaultValueArray] = useState<any | ''>([]);
    const closeButtonRef = useRef<HTMLButtonElement | null>(null);

    // Define a custom validation function
const validateDefaultValue = (value: string, context: any) => {
    const { selectedDataTypeOptionDropDownValue } = context;

    // Max length condition
    if (['7e295184-9623-4445-b99f-48f07929dce5', 'bacd6824-9011-4c30-864f-0899fefc004f'].includes(selectedDataTypeOptionDropDownValue) && value.length > 5) {
        return 'Must be 5 characters or less';
    }

    // Additional conditions can be added here...

    return undefined; // No error
};

    const formik = useFormik({
        initialValues: {
            ...currentFieldsData,
        },
        enableReinitialize: true,
        validationSchema: yup.object().shape({
            MasterCustomDataTypeId: yup
            .string()
            .label(getValueFromResource('MasterCustomDataTypeId', dispatch, t))
            .trim()
            .required(getValueFromResource('Data Type is required', dispatch, t)),
        
        CustomFieldName: yup
            .string()
            .label(getValueFromResource('CustomFieldName', dispatch, t))
            .trim()
            .required(getValueFromResource('Custom Field Name is required', dispatch, t))
            .max(100, getValueFromResource('Custom Field Name must not exceed 100 Characters', dispatch, t)),
        
        CustomFieldCaption: yup
            .string()
            .label(getValueFromResource('CustomFieldCaption', dispatch, t))
            .trim()
            .required(getValueFromResource('Custom Field Caption is required', dispatch, t))
            .max(100, getValueFromResource('Custom Field Caption must not exceed 100 Characters', dispatch, t)),
            DefaultValue: yup.string()
                .test('conditional-validation', 'Validation error', function (value : any) {
                    // Define the condition for max length
                    if (['7e295184-9623-4445-b99f-48f07929dce5', 'bacd6824-9011-4c30-864f-0899fefc004f'].includes(selectedDataTypeOptionDropDownValue)) {
                        if (value && value.length > 500) {
                            return this.createError({ message: 'Default Value must not exceed 500 Characters' });
                        }
                    }
                    // Additional conditions can be added here...
                    return true; // Validation passed
                })
        }),
        onSubmit: (values, action) => {
            handleSubmit(values);
            action.resetForm();
        },
    });

    useEffect(() => {
        let DefaultValueArray = [
            { value: 'None', label: 'None' }
        ]
        setDefaultValueArray(DefaultValueArray);
    }, [])

    const getDataTypeAsync = async () => {
        const response = await fetchAPI("api/V2/CustomFields/MasterCustomDataType", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.MasterCustomDataTypeId;
            item.label = item.MasterCustomDataTypeName;
            delete item.MasterCustomDataTypeId;
            delete item.MasterCustomDataTypeName;
        });
        setDataTypeArray(json.Data);
        if (json?.Data?.length > 0) {
            const firstOption = json.Data[0];
            setSelectedDataTypeOptionDropDown(firstOption);
            setSelectedDataTypeOptionDropDownValue(firstOption.value);
        }
    }

    useEffect(() => {
        getDataTypeAsync();
    }, [])


    useEffect(() => {
        let stateItem: any = {}
        if (Object.keys(selectedRecord).length > 0) {
            const tempObj: any = selectedRecord;
            Object.keys(CustomFieldInitialsForUpdate).map((item) => {
                return stateItem[item] = tempObj[item];
            })
            stateItem.IsDisabled = stateItem.IsDisabled === 'Yes' ? true : false;
            stateItem.IsRequired = stateItem.IsRequired === 'Yes' ? true : false;
            setCurrentFieldsData(stateItem);
            setSelectedDataTypeOptionDropDown(dataTypeArray.find((DataType: any) => DataType.value == stateItem.MasterCustomDataTypeId));
            const selectedRow = dataTypeArray.find((DataType: any) => DataType.value == stateItem.MasterCustomDataTypeId);
            const selectedField = selectedRow ? selectedRow.value : "";
            setSelectedDataTypeOptionDropDownValue(selectedField);
            if (typeof stateItem.DropDownOptions === 'string') {
                const selectedItemsArray = stateItem.DropDownOptions.split('+').map((item: string) => item.trim());
                setSelectedItems(selectedItemsArray);
                if (selectedItemsArray.length > 0) {
                    setDefaultValueArray([{ value: 'None', label: 'None' }])
                    selectedItemsArray.map((item: any, index: number) => (
                        setDefaultValueArray((prevArray: any) => [...prevArray, { value: item, label: item }])
                    ))
                }
            }
        }
        else {
            formik.resetForm();
            setSelectedItems([]);
            setDefaultValueArray([{ value: 'None', label: 'None' }]);
            if (dataTypeArray.length > 0) {
                const firstOption = dataTypeArray[0];
                setSelectedDataTypeOptionDropDown(firstOption);
                setSelectedDataTypeOptionDropDownValue(firstOption.value);
                setCurrentFieldsData({...CustomFieldInitialsForAdd,'MasterEntityTypeId': MasterEntityTypeId,'MasterCustomDataTypeId': firstOption.value});
            } else {
                setSelectedDataTypeOptionDropDown({ value: -1, label: '' });
                setSelectedDataTypeOptionDropDownValue('-1');
                setCurrentFieldsData({ ...CustomFieldInitialsForAdd, 'MasterEntityTypeId': MasterEntityTypeId });
            }
        }
    }, [selectedRecord])

    const handleDataTypeOptionChange = (data: any) => {
        const { value, label } = data;
        setSelectedDataTypeOptionDropDown(dataTypeArray.find((DataType: any) => DataType.value === value));
        setSelectedDataTypeOptionDropDownValue(dataTypeArray.find((DataType: any) => DataType.value === value).value);
        setCurrentFieldsData({ ...formik.values, 'MasterCustomDataTypeId': value });
    };
    const handleDefaultValueChange = (data: any) => {
        const { value, label } = data;
    };

    const CheckCustomFieldName = async () => {
        let url = ''
        if (formik.values.AccountCustomFieldId !== undefined) {
            url = "api/V2/CustomFields/CheckCustomFieldName/" + MasterEntityTypeId + "/" + formik.values.CustomFieldName + "/" + formik.values.AccountCustomFieldId + "";
        }
        else {
            url = "api/V2/CustomFields/CheckCustomFieldName/" + MasterEntityTypeId + "/" + formik.values.CustomFieldName + "";
        }
        const response = await fetchAPI(url, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        return json;

    }
    const handleSubmit = async (e: any) => {
        if (await CheckCustomFieldName() == false) {
            if (Object.keys(selectedRecord).length > 0) {
                dispatch(updateAccountCustomFieldAsync(formik.values))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        originalPromiseResult.StatusCode === "200" ?
                            ShowToast("Custom Field Update Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                             dispatch(getDataByMasterEntityTypeIdAsync(MasterEntityTypeId));
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    })
            }
            else {
                dispatch(addAccountCustomFieldAsync(formik.values))
                    .unwrap()
                    .then((originalPromiseResult) => {
                        originalPromiseResult.StatusCode === "201" ?
                            ShowToast("Custom Field Added Successfully", 'Success', "success", "toast-top-right") :
                            ShowToast('error', originalPromiseResult.ResponseMessage, "error", "toast-top-right");
                            dispatch(getDataByMasterEntityTypeIdAsync(MasterEntityTypeId));
                            
                    })
                    .catch((rejectedValueOrSerializedError) => {
                        ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                    })
            }
            if (closeButtonRef.current) {
                closeButtonRef.current.click();
            }
        }
        else {
            alert('Custom Field Name Already Exist.');
        }
    }

    const handleAddItem = () => {
        if (inputValue.trim() === '') return;
        if (selectedItems.findIndex((item) => item == inputValue.trim()) < 0) {
            const updatedFormikValues = { ...formik.values, 'DropDownOptions': [...selectedItems, inputValue.trim()].join('+') };
            setCurrentFieldsData(updatedFormikValues);
            setSelectedItems((prevItems) => [...prevItems, inputValue.trim()]);
            setDefaultValueArray((prevArray: any) => [...prevArray, { value: inputValue.trim(), label: inputValue.trim() }]);
        } else {
            alert(inputValue + ' already exists!');
        }
        setInputValue('');
    };

    const handleRemoveSelectedItems = () => {
        const selectedOptionValues = Array.from(selectRef.current?.selectedOptions || []).map(option => option.value);
        setSelectedItems(prevSelectedItems => prevSelectedItems.filter(item => !selectedOptionValues.includes(item)));
        setDefaultValueArray((prevDefaultValueArray: any) => prevDefaultValueArray.filter((item: any) => !selectedOptionValues.includes(item.value)));
        const optionsArray = formik.values.DropDownOptions.split('+');
        const updatedOptionsArray = optionsArray.filter((item: any) => item !== selectedOptionValues[0]);
        const updatedDropDownOptions = updatedOptionsArray.join('+');
        setCurrentFieldsData({ ...formik.values, 'DropDownOptions': updatedDropDownOptions });

    };

    const handleItemClick = (e: React.MouseEvent<HTMLOptionElement, MouseEvent>) => {
        const target = e.target as HTMLOptionElement;
        target.selected = true;
        setInputValue(target.value);
        setSelectedItemToUpdate(target.value);
    };

    const handleUpdate = () => {
        if (selectedItemToUpdate && inputValue.trim() !== '') {
            const indexOfSelectedItemToUpdate = selectedItems.findIndex((item) => item === selectedItemToUpdate);
            if (indexOfSelectedItemToUpdate !== -1) {
                const updatedSelectedItems = [...selectedItems];
                updatedSelectedItems[indexOfSelectedItemToUpdate] = inputValue;
                setSelectedItems(updatedSelectedItems);
                setDefaultValueArray((prevDefaultValueArray: any) =>
                    prevDefaultValueArray.map((item: any) =>
                        item.value === selectedItemToUpdate ? { value: inputValue, label: inputValue } : item
                    )
                );
                setCurrentFieldsData({ ...formik.values, 'DropDownOptions': updatedSelectedItems.join('+') });
                setInputValue('');
                setSelectedItemToUpdate(null);
            }
        }
    };

    const handleCloseOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
    }
    return (
        <>
            {/* <form > */}
            <div className='card-body card-pad'>
                {isLoading ?
                    <div className="col-md-12">
                        <span className='indicator-progress' style={{ display: 'block' }}>
                            <span className='spinner-border spinner-border-md ms-2'></span>
                        </span>
                    </div>
                    : <>
                        <div className='row'>
                            <div className="col-md-6 mb-2">
                                <label className="fs-7 fs-7 fw-normal mb-2">
                                    {/* {t('Data Type')} */}
                                    {getValueFromResource('Data Type',dispatch, t)}
                                    </label>
                                <Select
                                    value={formik.values.MasterCustomDataTypeId ==  "" ? dataTypeArray[0] :  dataTypeArray.find((option: any) => option.value == formik.values.MasterCustomDataTypeId)}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    id="MasterCustomDataTypeId"
                                    name="MasterCustomDataTypeId"
                                    onBlur={() => formik.setFieldTouched('MasterCustomDataTypeId', true)}
                                    onChange={(selectedOption) => {
                                        formik.handleChange({
                                            target: {
                                                id: "MasterCustomDataTypeId",
                                                value: selectedOption?.value
                                            },
                                        });
                                        handleDataTypeOptionChange(selectedOption);
                                    }}
                                    options={dataTypeArray}
                                    styles={dropDownSelectionStyles}
                                    maxMenuHeight={maxMenuHeight}
                                    isDisabled={Object.keys(selectedRecord).length > 0 ? true : false}
                                />
                                <div>
                                    {formik.touched.MasterCustomDataTypeId && formik.errors.MasterCustomDataTypeId &&
                                        <p className='errorMsg'>{formik.errors.MasterCustomDataTypeId as string}</p>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6 mb-2">
                                <label className="fs-7 fs-7 fw-normal mb-2">
                                    {/* {t('Custom Field Name')} */}
                                    {getValueFromResource('Custom Field Name',dispatch, t)}
                                    </label>
                                <input type="text"
                                    className="form-control fs-7 fw-normal"
                                    id='CustomFieldName'
                                    name="CustomFieldName"
                                    value={formik.values.CustomFieldName}
                                    onChange={formik.handleChange('CustomFieldName')}
                                    onBlur={() => formik.setFieldTouched('CustomFieldName')}
                                />
                                <div>
                                    {formik.touched.CustomFieldName && formik.errors.CustomFieldName &&
                                        <p className='errorMsg'>{formik.errors.CustomFieldName as string}</p>
                                    }
                                </div>
                            </div>
                            <div className="col-md-6 mb-2 mt-3">
                                <label className="fs-7 fs-7 fw-normal mb-2">
                                    {/* {t('Custom Field Caption')} */}
                                    {getValueFromResource('Custom Field Caption',dispatch, t)}
                                    </label>
                                <input type="text"
                                    className="form-control fs-7 fw-normal"
                                    id='CustomFieldCaption'
                                    name="CustomFieldCaption"
                                    value={formik.values.CustomFieldCaption}
                                    onChange={formik.handleChange('CustomFieldCaption')}
                                    onBlur={() => formik.setFieldTouched('CustomFieldCaption')}
                                />
                                <div>
                                    {formik.touched.CustomFieldCaption && formik.errors.CustomFieldCaption &&
                                        <p className='errorMsg'>{formik.errors.CustomFieldCaption as string}</p>
                                    }
                                </div>
                            </div>
                            {['7e295184-9623-4445-b99f-48f07929dce5', 'bacd6824-9011-4c30-864f-0899fefc004f'].includes(selectedDataTypeOptionDropDownValue) ?
                                <div className="col-md-6 mb-2 mt-3">
                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                        {/* {t('Default Value')} */}
                                        {getValueFromResource('Default Value',dispatch, t)}
                                        </label>
                                    <input type="text"
                                        className="form-control fs-7 fw-normal"
                                        id='DefaultValue'
                                        name="DefaultValue"
                                        value={formik.values.DefaultValue}
                                        onChange={formik.handleChange('DefaultValue')}
                                        onBlur={() => formik.setFieldTouched('DefaultValue')}
                                    />
                                      <div>
                                    {formik.touched.DefaultValue && formik.errors.DefaultValue &&
                                        <p className='errorMsg'>{formik.errors.DefaultValue as string}</p>
                                    }
                                </div>
                                </div>
                                : (
                                    null
                                )}
                            {['574ded9c-7ad4-4649-8b39-d6741dd0ddca'].includes(selectedDataTypeOptionDropDownValue) ?
                                <div className="col-md-6 mb-2 mt-3">
                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                        {/* {t('Default Value')} */}
                                        {getValueFromResource('Default Value',dispatch, t)}
                                        </label>
                                    <Select
                                        value={formik.values.DefaultValue != "" ? DefaultValueArray.find((option: any) => option.value === formik.values.DefaultValue) : ""}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        id='DefaultValue'
                                        name="DefaultValue"
                                        options={DefaultValueArray}
                                        onChange={(selectedOption) => {
                                            formik.handleChange({
                                                target: {
                                                    id: "DefaultValue",
                                                    value: selectedOption?.value
                                                },
                                            });
                                            handleDefaultValueChange(selectedOption);
                                        }}
                                    />
                                </div>
                                : (
                                    null
                                )}
                            {['bacd6824-9011-4c30-864f-0899fefc004f'].includes(selectedDataTypeOptionDropDownValue) ? (
                                <>
                                    <div className="col-md-6 mb-2 mt-3">
                                        <label className="fs-7 fs-7 fw-normal mb-2">
                                            {/* {t('Minimum Value')} */}
                                            {getValueFromResource('Minimum Value',dispatch, t)}
                                            </label>
                                        <input type="number"
                                            className="form-control fs-7 fw-normal"
                                            id='MinimumValue'
                                            name='MinimumValue'
                                            value={formik.values.MinimumValue}
                                            onChange={formik.handleChange('MinimumValue')}
                                            onBlur={() => formik.setFieldTouched('MinimumValue')}
                                        />
                                    </div>
                                    <div className="col-md-6 mb-2 mt-3">
                                        <label className="fs-7 fs-7 fw-normal mb-2">
                                            {/* {t('Maximum Value')} */}
                                            {getValueFromResource('Maximum Value',dispatch, t)}
                                            </label>
                                        <input type="number"
                                            className="form-control fs-7 fw-normal"
                                            id='MaximumValue'
                                            name='MaximumValue'
                                            value={formik.values.MaximumValue}
                                            onChange={formik.handleChange('MaximumValue')}
                                            onBlur={() => formik.setFieldTouched('MaximumValue')}
                                        />
                                    </div>
                                </>
                            ) : (
                                null
                            )}
                            {selectedDataTypeOptionDropDownValue == '7e295184-9623-4445-b99f-48f07929dce5' ? (
                                <div className="col-md-6 mb-2 mt-3">
                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                        {/* {t('Maximum Length')} */}
                                        {getValueFromResource('Maximum Length',dispatch, t)}
                                        </label>
                                    <input type="text"
                                        className="form-control fs-7 fw-normal"
                                        id='MaximumLength'
                                        name='MaximumLength'
                                        value={formik.values.MaximumLength}
                                        onChange={formik.handleChange('MaximumLength')}
                                        onBlur={() => formik.setFieldTouched('MaximumLength')}
                                    />
                                </div>
                            ) : (
                                null
                            )}

                            {['574ded9c-7ad4-4649-8b39-d6741dd0ddca'].includes(selectedDataTypeOptionDropDownValue) ?
                                <div className="col-md-6 mb-2 mt-3">
                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                        {/* {t('Options')} */}
                                        {getValueFromResource('Options',dispatch, t)}
                                        </label>
                                    <input
                                        type="text"
                                        value={inputValue}
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setInputValue(e.target.value)}
                                        placeholder={t("Enter new item")}
                                        className="form-control fs-7 fw-normal"
                                    />
                                </div>
                                : (
                                    null
                                )}
                            <div className="col-md-6 mb-2 mt-3">
                                <label className="fs-7 fw-normal mb-2">
                                    {/* {t('Is Required')} */}
                                    {getValueFromResource('Is Required',dispatch, t)}
                                    </label>
                                <div className="form-check form-switch form-check-custom form-check-solid me-10  ">
                                    <input type="checkbox"
                                        className="form-check-input h-20px w-30px"
                                        checked={formik.values.IsRequired}
                                        id="IsRequired"
                                        name="IsRequired"
                                        onChange={formik.handleChange('IsRequired')}
                                    />
                                </div>
                            </div>
                            {['574ded9c-7ad4-4649-8b39-d6741dd0ddca'].includes(selectedDataTypeOptionDropDownValue) ?
                                <>
                                    <div className="col-md-6 mb-2 mt-3">
                                        <select
                                            ref={selectRef}
                                            multiple
                                            size={10}
                                            className='form-control'
                                        >
                                            {selectedItems.map((item, index) => (
                                                <option key={index} selected={false} onClick={handleItemClick}>
                                                    {item}
                                                </option>
                                            ))}
                                        </select>

                                        <div onClick={handleAddItem} className="icon-container">
                                            <KTIcon iconName='plus' className='fs-3 custom-pointer-cursor' />
                                            <span className="tooltip-text" >
                                                {/* Add */}
                                                {getValueFromResource('Add',dispatch, t)}
                                                </span>
                                        </div>
                                        <div onClick={handleUpdate} className="icon-container">
                                            <KTIcon iconName='pencil' className='fs-3 custom-pointer-cursor' />
                                            <span className="tooltip-text" >
                                                {/* Update */}
                                                {getValueFromResource('Update',dispatch, t)}
                                                </span>
                                        </div>
                                        <div onClick={handleRemoveSelectedItems} className="icon-container">
                                            <KTIcon iconName='trash' className='fs-3 custom-pointer-cursor' />
                                            <span className="tooltip-text" >
                                                {/* Delete */}
                                                {getValueFromResource('Delete',dispatch, t)}
                                                </span>
                                        </div>
                                        {/* <button type="button" style={{ marginLeft: '0px', marginTop: '2px' }} className="btn btn-success btn-sm" onClick={handleAddItem}> {t('Add')}</button>
                                            <button type="button" style={{ marginLeft: '2px', marginTop: '2px' }} className="btn btn-success btn-sm" onClick={handleUpdate}>{t('Update')}</button>
                                            <button type="button" style={{ marginLeft: '2px', marginTop: '2px' }} className="btn btn-success btn-sm" onClick={handleRemoveSelectedItems}>{t('Delete')}</button> */}
                                    </div>
                                </>

                                : (
                                    null
                                )}
                            {(Object.keys(selectedRecord).length > 0) ? (
                                <div className="col-md-6 mb-2 mt-3">
                                    <label className="fs-7 fw-normal mb-2">
                                        {/* {t('Disabled')} */}
                                        {getValueFromResource('Disabled',dispatch, t)}
                                        </label>
                                    <div className="form-check form-switch form-check-custom form-check-solid me-10">
                                        <input type="checkbox"
                                            className="form-check-input h-20px w-30px"
                                            checked={formik.values.IsDisabled}
                                            id="IsDisabled"
                                            name="IsDisabled"
                                            onChange={formik.handleChange('IsDisabled')}
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </>
                     
                }
                {Object.keys(formik.errors).length > 0 && (
                        <div className="mt-3 alert alert-danger">
                            <strong>
                                {/* {t('Error Summary')}: */}
                                {getValueFromResource('Cancel',dispatch, t)}:
                                </strong>
                            <ul>
                                {Object.keys(formik.errors).map((fieldName, index) => (
                                    <li key={index}>{formik.errors[fieldName] as string}</li>
                                ))}
                            </ul>
                        </div>
                    )}
            </div>
            <div className='card-footer pt-4 '>
                <div className='d-flex flex-stack float-end'>
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                        id="kt_OffCanvas"
                        onClick={handleCloseOnClickEvent}
                    >
                        {/* {t('Cancel')} */}
                        {getValueFromResource('Cancel',dispatch, t)}
                    </button>

                    <button type="button"
                        className="btn btn-sm btn-primary"
                        onClick={() => formik.handleSubmit()} disabled={!formik.isValid}

                    >
                        {/* {t('Save')} */}
                        {getValueFromResource('Save',dispatch, t)}
                    </button>
                </div>
            </div>
            
        </>
    )
}
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}
